import React, { useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';

import ProjectCreateForm from '../forms/ProjectCreateForm';
import ProjectEditForm from '../forms/ProjectEditForm';

const ProjectModal = ({ visible, onClose, submitForm, formProps, title }) => {
  const formRef = useRef<any>();

  const formSubmit = (id, values) => {
    submitForm(id, values);
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {formProps ? (
            <ProjectEditForm ref={formRef} formProps={formProps} submit={formSubmit} />
          ) : (
            <ProjectCreateForm ref={formRef} submit={formSubmit} />
          )}
        </DialogBody>
        <DialogFooter>
          <Button
            data-testid="project-modal-close-btn"
            key={1}
            variant="outline"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button
            data-testid="project-modal-submit-btn"
            key={2}
            onClick={() => formRef?.current?.submitForm()}
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ProjectModal;
